<template>
  <div>

        <div v-if="focus && focus.state == 'ontrack'">
          <div style="display:flex;align-items: center">
              <div v-if="tool && tool.settings && tool.settings.emotes" >
                  <div style="display:flex">
                      <div style="flex-grow:0; text-align: center">
                          <div id="my-emote"
                               class="myemote"
                          >
                              {{ selectedEmoji && selectedEmoji.char }}
                          </div>
                      </div>
                  </div>
                  <div style="display:flex">
                      <div v-for="(anEmoji,index) in tool.settings.emotes"
                             :key="index"
                             class="emoteoptions"
                             @click="showMyEmoji(anEmoji)"
                      > {{ anEmoji.char }}
                      </div>
                  </div>
              </div>
              <div v-else>
                  Place on DECK in order to set-up
              </div>
          </div>
        </div>

        <div v-else-if="focus && focus.state == 'ondeck'">
            <div style="display:flex; margin-bottom: 2rem" >
              <div :cols="9">
                <div style="display:flex;width: 100%">Select 10 emojis</div>
                <div style="display:flex">
                  <div v-for="(emoji,index) in selectedEmojis" :key="index" @click="handleRemove10Emoji(emoji)" class="emoteoptions">
                    {{emoji.char}}
                  </div>
                </div>
              </div>
              <div>
                <b-button @click="saveEmojis"> Save </b-button>
              </div>
            </div>
            <div style="display:flex" class="emote-body">
              <div v-for="(anEmoji,index) in emojis"
                  :key="index"
                  @click="selectedEmojis.length < 10 ? handleSelect10Emoji(anEmoji) : () => {}"
                  class="emoteoptions"> {{ anEmoji.char }}
              </div>
            </div>
        </div>

        <div v-if="focus && focus.state == 'stationed'">
           <div style="display:flex">
             STATIONED
            </div>
        </div>
  </div>
</template>
<script>
import { emojis } from './emojis.json'

export default {
  name: 'emote-web-component',
  components: {
  },
  props: {
    tool: {
      type: Object,
      required: false,
      default:()=>{}
    },
    focus: {
      type: Object,
      required: false,
      default:()=>{}
    },
    user: {
      type: String,
      default: () => ""
    },
    setTracker: {
      type: Function,
      default: () => () => {}
    },
    setSetting: {
      type: Function,
      default: () => () => {}
    },
  },
  methods:{
    showMyEmoji(emoji) {
      this.selectedEmoji = emoji
      let trackEmote = {_created_at: new Date(), emote: this.selectedEmoji.char}
      this.setTracker({track: trackEmote, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
      // this.$store.dispatch('tools/addTrackIntoEmoteTool', {track: trackEmote, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
    },
    handleSelect10Emoji(emoji) {
      this.selectedEmojis.push(emoji)
    },
    handleRemove10Emoji(emoji) {
      this.selectedEmojis = this.selectedEmojis.filter(el => el.char !== emoji.char)
    },
    saveEmojis() {
      let emojis = this.selectedEmojis.map(el => ({
        _created_at: new Date(),
        _created_by: '/users/'+this.user,
        char: el.char,
        name: el.name
      }))
      this.setSetting({emotes: emojis, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
      // this.$store.dispatch('tools/addEmoteIntoYtbTool', {emotes: emojis, focusId: this.focus.focusId, tools_id: this.tool.tools_id})    
    },
  },
  computed: {
  },
  mounted() {
  },
  data: function() {
    return {
      emojis,
      selectedEmojis: this.tool && this.tool.settings && this.tool.settings.emotes ? this.tool.settings.emotes : [],
      selectedEmoji: null
    }
  },
}
</script>
<style lang="scss" module>
  @import './style.module.scss';
</style>

<style scoped>
  .body-card {
    overflow-y: auto;
  }
  .emote-body {
    width: 100%;
    overflow-x: auto;
  }
  .myemote {
      cursor: pointer;
      display: flex;
      font-size: 50px;
      height: 80px;
      width: 80px;
      border: 1px solid #272f75;
      border-radius: 40px;
      justify-content: center;
  }
  .emoteoptions {
      cursor: pointer;
      display: flex;
      font-size: 15px;
      flex-grow: 0;
  }
</style>
